import axios, { AxiosRequestConfig } from "axios";
import { api, apiWithoutInterceptors } from "../api";
import { ISignIn } from "../utils/validation/schemas/validationSignIn";
import { ISignUp } from "../utils/validation/schemas/validationSignUp";
import { useQuery } from "@tanstack/react-query";

export const loginUser = async (data: ISignIn, params?: AxiosRequestConfig) => {
  data.email = data.email.toLowerCase();
  const response = await api.post("/auth", data, { ...params });
  return response;
};

export const signUpUser = (data: ISignUp, params?: AxiosRequestConfig) => {
  data.email = data.email.toLowerCase();
  return api.post("/auth/signup", data, { ...params });
};

export const logoutUser = (data: {
  refreshToken: string | null;
  accessToken: string | null;
}) => {
  return api.post("/auth/logout", data);
};
export interface IRecoveryPassword {
  email: string;
  // phone: string;
  client_ip: string;
  whitelabel_id: number;
}

export const recoveryPassword = (data: IRecoveryPassword) => {
  data.email = data.email.toLowerCase();
  return api.post("/auth/forgotpassword", data);
};

export interface IPinValidation {
  user_email_hash: string;
  secret_pin: string;
  client_ip: string;
}

export const pinValidation = (data: IPinValidation) => {
  return api.post("/auth/pinvalidation", data);
};

interface IChangePassword {
  user_token: string;
  session_token: string;
  old_password: string;
  new_password: string;
}

export const changePassword = (data: IChangePassword) => {
  return api.post("/auth/changepassword", data);
};

export interface IResetPassword {
  user_email_hash: string;
  secret_phrase: string;
  new_password: string;
  new_password_confirmation?: string;
  client_ip: string;
}

export const resetPassword = (data: IResetPassword) => {
  return api.post("/auth/resetpassword", data);
};

export const getUserIp = () => {
  return axios.get("https://api.ipify.org?format=json");
};

export const useUserIP = () => {
  return useQuery({
    queryKey: ["user-ip"],
    queryFn: getUserIp,
    keepPreviousData: true,
    cacheTime: 1000 * 60 * 60,
  });
};

export const renewToken = () => {
  return api.post("/auth/token/renew");
};

export const loginGenialWithToken = async (
  token: string,
  params?: AxiosRequestConfig
) => {
  const tokenData = { token: token };

  const response = await apiWithoutInterceptors.post(
    "/auth/g/sso/login",
    tokenData,
    {
      ...params,
    }
  );
  return response;
};
